module.exports = __webpack_public_path__ + "static/media/ganadores.0a8f7316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/ganadores.png
// module id = 1104
// module chunks = 0